export default __webpack_public_path__ + "static/kuru-nasil-c5cc61d7e0da7b02370dc3f4c581fbbd.jpg";